export default __webpack_public_path__ + "static/media/icon-copy-red.1698b11e.svg";